import { render } from "./QuestionBankBrowser.vue?vue&type=template&id=1b224fca&scoped=true"
import script from "./QuestionBankBrowser.vue?vue&type=script&lang=js"
export * from "./QuestionBankBrowser.vue?vue&type=script&lang=js"

import "./QuestionBankBrowser.vue?vue&type=style&index=0&id=1b224fca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b224fca"]])

export default __exports__